import { client } from "../../helpers/client";

export const warmupLambdas = () => {
  client.get('/api/health/version');
};
